<div class="spot-backdrop" (click)="closed.emit()">
  <div class="spot-card" (click)="$event.stopPropagation()">
    <div class="spot-header">
      <div class="spot-heading">
        <span class="spot-title">{{ title() }}</span>
        @if (subtitle()) {
          <span class="spot-subtitle">{{ subtitle() }}</span>
        }
      </div>
      <button class="spot-close" type="button" (click)="closed.emit()">✕</button>
    </div>

    <div class="spot-body vg-scroll">
      @if (loading()) {
        <div class="spot-state">Loading message…</div>
      } @else if (error()) {
        <div class="spot-state spot-error">{{ error() }}</div>
      } @else {
        <pre>{{ xml() }}</pre>
      }
    </div>
  </div>
</div>
